import React, { FunctionComponent, useMemo } from "react";
import useAcuratePercentage from "../hooks/useAcuratePercentage";

type OwnProps = {
  topOffset?: number;
  students: number[];
  statsByEc: {
    belowColor?: string;
    atOrAboveColor?: string;
    below: number[];
    atOrAbove: number[];
  } | null;
};

type Props = OwnProps;

const BellowCell: FunctionComponent<Props> = (props) => {
  const { statsByEc, students, topOffset } = props;
  const { getPercentages } = useAcuratePercentage();
  if (!statsByEc) {
    return (
      <td rowSpan={2} className="text-center p-2" style={{ top: topOffset }}>
        N/A
      </td>
    );
  }

  const belowCount = useMemo(
    () => statsByEc.below.filter((sId) => students.includes(sId)).length || 0,
    [statsByEc.below]
  );

  const atOrAboveCount = useMemo(
    () =>
      statsByEc.atOrAbove.filter((sId) => students.includes(sId)).length || 0,
    [statsByEc.atOrAbove]
  );

  return (
    <td
      className="text-center p-4 text-nowrap"
      //style={{ backgroundColor: statsByEc.belowColor, top: topOffset }}
      style={{ backgroundColor: "rgb(255, 209, 218)", top: topOffset }}

    >
      <strong>{`${getPercentages(belowCount, atOrAboveCount).belowPercent}%`}</strong>
      &nbsp;({belowCount})
    </td>
  );
};

export default BellowCell;
